import { render, staticRenderFns } from "./device-add-new.vue?vue&type=template&id=225dcf54&scoped=true"
import script from "./device-add-new.vue?vue&type=script&lang=js"
export * from "./device-add-new.vue?vue&type=script&lang=js"
import style0 from "./device-add-new.vue?vue&type=style&index=0&id=225dcf54&prod&scoped=true&lang=scss"
import style1 from "./device-add-new.vue?vue&type=style&index=1&id=225dcf54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225dcf54",
  null
  
)

export default component.exports